import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as solidStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as regStar } from '@fortawesome/free-regular-svg-icons';
import { longFormat } from '../../constants/date';
import imgReports from '../../assets/img/forReports';

function ReportItem({
  report, idx, inFavorites, onToggleFavorites,
}) {
  const updated = useMemo(() => {
    const d = new Date(report.updated);
    return d.toLocaleString('uk', longFormat);
  }, [report.updated]);

  const imgIndex = (imgReports.length < idx)
    ? (idx - Math.round(idx / imgReports.length) * imgReports.length) : idx;

  return (
    <Card className="my-2 h-100">
      <div className="text-center">
        {report.avatarImg
          ? (<Card.Img src={report.avatarImg} />)
          : (<Card.Img src={imgReports[imgIndex]} />)}

      </div>
      <Card.Body className="d-flex flex-column">
        <div className="d-flex gap-1 align-items-start">
          <Card.Title className="fs-1 fw-bold flex-fill">
            {report.name}
          </Card.Title>
          <Button size="sm" title="Додати в улюблені" variant="link" onClick={() => onToggleFavorites(report.id)}>
            <span className="sr-only">Додати в улюблені</span>
            <FontAwesomeIcon icon={inFavorites ? solidStar : regStar} className="text-warning" />
          </Button>
        </div>
        <Card.Text className="fst-italic flex-fill">
          {report.description}
        </Card.Text>
        <Button as={Link} color="primary" size="md" to={`/rep/${report.identifier}/${report.id}`}>
          Сформувати звіт
        </Button>
      </Card.Body>
      <Card.Footer>
        <small className="text-muted">
          {`Останнє оновлення: ${updated}`}
        </small>
      </Card.Footer>
    </Card>
  );
}

export const reportPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  repr: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  updated: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  avatarImg: PropTypes.string,
});

ReportItem.propTypes = {
  report: reportPropType.isRequired,
  idx: PropTypes.number.isRequired,
  inFavorites: PropTypes.bool,
  onToggleFavorites: PropTypes.func.isRequired,
};
ReportItem.defaultProps = {
  inFavorites: false,
};

export default ReportItem;
